<template>
		<module-tab name="待发货" enable-flex @mounted="searchHandle" @activated="$refs.table.update()">
			<m-search ref="search" @search="searchHandle">
				<m-search-item label="订单编号">
					<c-input name="order_number"></c-input>
				</m-search-item>
				<m-search-item label="商品ID">
					<c-input name="product_id"></c-input>
				</m-search-item>
				<m-search-item label="商品标题">
					<c-input name="product_name"></c-input>
				</m-search-item>
				<m-search-item label="下单时间" colspan="2">
					<c-datetime start-name="create_start_date" end-name="create_end_date" range></c-datetime>
				</m-search-item>
			</m-search>
<!--            <m-operate>
                <c-button @click="openImportDialog()" color="main" icon="excel">导入发货</c-button>
            </m-operate>-->
			<c-table ref="table" height="grow">
				<c-table-column
					width="360"
				>
					<template slot="head">
						<!-- <c-checkbox></c-checkbox> -->
						<span style="margin-left: 15px;">商品信息</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="单价"
					width="130"
					align-center
				></c-table-column>
				
				<c-table-column
					label="下单数"
					width="130"
					align-center
				></c-table-column>
				
				<c-table-column
					label="小计"
					width="130"
					align-center
				></c-table-column>
				
				<c-table-column
					label="已发货"
					width="130"
					align-center
				></c-table-column>

				<c-table-column
					label="待发货"
					width="130"
					align-center
				></c-table-column>

				<c-table-column
					label="操作"
					width="130"
					align-center
				></c-table-column>
				
				<template #custom="{data}">
					<div :key="data.id" class="order">
						<div class="order-head flex-between-center">
							<div class="flex-center">
								<!-- <c-checkbox></c-checkbox> -->
								<span class="number">订单号：{{data.order_number}}</span>
								<p class="info">下单时间：{{data.create_date}}，收件信息：{{data.receiving_name}},{{data.receiving_phone}},{{data.receiving_address}}</p>
							</div>
						</div>
						<div class="flex">
							<div class="order-product">
								<div v-for="(sku, i) in data.product_sku_list" :key="i" class="sku flex-center">
									<div class="sku-info flex-center flex-grow">
										<c-file class="sku-image" :src="sku.product_img_url" media></c-file>
										<div class="flex-grow">
                                            <p class="sku-name ellipsis">
                                                <span v-if="sku.product_itemnumber">{{sku.product_itemnumber}} - </span>
                                                {{sku.product_name}}
                                            </p>
											<p class="sku-sku">{{sku.product_sku_spec}}</p>
										</div>
									</div>
									<div class="sku-price">￥{{sku.product_unit_price}}</div>
									<div class="sku-count">{{sku.product_count}}</div>
									<div class="sku-price">￥{{sku.product_cost_money}}</div>
									<div class="sku-count">{{sku.send_count}}</div>
									<div class="sku-delivery_count">{{sku.product_count - sku.send_count}}</div>
								</div>
							</div>
							<div class="order-handle flex-column flex-center">
								<c-button color="main" @click="navigateTo(`/order_wait_delivery_detail/${data.order_number}`)">去发货</c-button>
							</div>
						</div>
					</div>
				</template>
			</c-table>

            <c-dialog ref="dialog" title="导入发货" width="600" @resolve="importDeliver">
                <c-form ref="deliverForm">
                    <c-form-item>
                        <c-link color="gray">
                            <a href="https://yci.oss-cn-hangzhou.aliyuncs.com/template/excel/%E8%AE%A2%E5%8D%95%E5%AF%BC%E5%85%A5%E5%8F%91%E8%B4%A7%E6%A8%A1%E6%9D%BF.xlsx" target="_blank" style="color:dodgerblue;">
                                点击这里下载
                            </a>
                            导入发货标准模板，填写相应信息后再导入文件完成发货
                        </c-link>
                    </c-form-item>
                    <c-form-item label="导入文件" required width="800">
                        <c-upload-file name="filePath" type="excel" tip="请上传发货模板文件"></c-upload-file>
                    </c-form-item>
                </c-form>
            </c-dialog>
		</module-tab>
</template>

<script>
	export default {
		props: {
			tab: String
		},
		
		data() {
			return {
				currentTab: {},
				orderStateName: {
					1: '待付款',
					2: '待发货',
					3: '待收货',
					5: '交易完结',
					6: '已关闭'
				}
			}
		},
		
		methods: {
			tabHandle(item, index) {
				if (index != this.tab) {
					this.navigateTo({
						query: {
							tab: index
						}
					})
				}
				
				this.currentTab = item;
				this.$refs.search.search();
			},

			searchHandle(data) {
				this.$refs.table.load({
					url: '/purchase/order/wait_delivery_detail_list',
					data: data
				});
			},

            openImportDialog() {
                this.$refs.deliverForm.clear();
                this.$refs.dialog.open();
            },

            //导入发货
            importDeliver(stop, next) {
                stop();
                this.$refs.deliverForm.submit({
                    url: '/purchase/order/importDeliver',
                    rule: {
                        filePath:'请上传导入文件'
                    },
                    dataFormatter: data => {
                        return data;
                    },
                    success:(data,res) => {
                        next();
                        this.$refs.search.search();
                        this.$confirm({
                            title: '执行结果',
                            message: res,  // 提示内容,
                            buttonName: '确定',  // 确定按钮文字
                            icon: 'success',
                            cancelButton: false  // 是否显示取消按钮
                        });
                    }
                });
            }
		}
	}
</script>

<style lang="stylus" scoped>
	.order {
		box-sizing: border-box;
		min-width: 1270px;
		border: 1px solid #eee;
		margin: 16px 0;
		
		&-head {
			height: 34px;
			border-bottom: 1px solid #eee;
			padding: 0 8px;
			font-size: 12px;
			background: #F8F8F8;
			
			.number {
				margin-left: 15px;
				color: #333;
			}
			
			.info {
				border-left: 1px solid #999;
				padding-left: 8px;
				margin-left: 15px;
				color: #999;
			}
		}
		
		&-product {
			flex-grow: 1140;
			flex-basis: 1140px;
			
			.sku {
				&:nth-child(n+2) {
					border-top: 1px solid #eee;
				}
				
				&-info {
					flex-grow: 360;
					flex-basis: 360px;
					box-sizing: border-box;
					padding: 10px 0 10px 14px;
				}
				
				&-image {
					width: 80px;
					height: 80px;
					margin-right: 24px;
				}
				
				&-name {
					font-size: 12px;
					color: #666;
				}
				
				&-sku {
					margin-top: 10px;
					font-size: 12px;
				}
				
				&-price,
				&-count {
					flex-grow: 130;
					flex-basis: 130px;
					font-size: 13px;
					text-align: center;
					color: #333;
				}
				&-delivery_count{
					flex-grow: 130;
					flex-basis: 130px;
					font-size: 22px;
					text-align: center;
					color: red;
				}
			}
		}
		
		&-sum,
		&-state,
		&-handle {
			flex-grow: 130;
			flex-basis: 130px;
			box-sizing: border-box;
			border-left: 1px solid #eee;
		}
		
		&-sum {
			line-height: 20px;
			font-size: 12px;
			text-align: center;
			color: #333;
			
			span {
				color: #888;
			}
		}
		
		&-state {
			line-height: 20px;
			font-size: 12px;
			
			a {
				color: #0060EF;
			}
		}
		
		&-handle {
			.c-button {
				width: 6em;
				
				&:nth-child(n+2) {
					margin-top: 8px;
				}
			}
		}
	}
</style>
